export const DAILY_MAP_TOGGLE_OPTIONS = Object.freeze({
  TOTAL_REPOSESSIONS_TAB: 'totalRepossessions',
  SPOTTED_TAB: 'spotted',
  SPOTTED_NOT_SECURED_TAB: 'spottedNotSecured',
});

export type Coordinate = {
  lat: number;
  lng: number;
};
